window.alanDebugLog = alanDebugLog;
window.alanDebugInfo = alanDebugInfo;
window.alanDebugLocalInfo = alanDebugLocalInfo;

export function alanDebugLog(str: string) {
    console.log(`ALAN LOG: ${str}`);
}

export function alanDebugInfo(str: string) {
    console.info(`ALAN INFO: ${str}`);
}

export function alanDebugLocalInfo(str: string) {
    console.info(`ALAN LOCAL BUILD INFO: ${str}`);
}